export default __webpack_public_path__ + "static/media/image06.05426e57.jfif";